import { NgModule } from '@angular/core';
import { InfoContentComponent } from './info-content/info-content.component';
import { InfoPageComponent } from './info-page.component';
import { InfoWrapperComponent } from './info-wrapper/info-wrapper.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizePipe } from '../../localize/localize.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { UnescapePipe } from '../shared/pipes/unescape.pipe';
import { ErrorComponent } from '../shared/error/error.component';

@NgModule({
	declarations: [
		InfoContentComponent,
		InfoPageComponent,
		InfoWrapperComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		LocalizePipe,
		TranslateModule,
		RecaptchaModule,
		RecaptchaFormsModule,
		UnescapePipe,
		ErrorComponent,
	],
	exports: [
		InfoContentComponent,
		InfoPageComponent,
		InfoWrapperComponent
	]
})
export class InfoPageModule { }
